import { createFileRoute, Outlet } from "@tanstack/react-router";
import { LxpLayout } from "@/components/lexpractiq/LxpLayout";

export const Route = createFileRoute("/lexpractiq")({
  component: () => (
    <LxpLayout>
      <Outlet />
    </LxpLayout>
  ),
});
